import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import ReactGA from 'react-ga'
import Zoom from '@material-ui/core/Zoom'
import Icon from 'react-icons-kit'
import { ic_check_circle } from 'react-icons-kit/md/ic_check_circle'
import { ic_lock } from 'react-icons-kit/md/ic_lock'
import { lock } from 'react-icons-kit/fa/lock'
import { connect } from 'react-redux'

import './VideoThumb.css'

class VideoThumb extends Component {
	// componentDidMount(){
	// this.refs[short_code].play()
	// }
	render = () => {
		let { video, premium: user_premium } = this.props
		let { short_code, thumb_url, preview_url, premium, } = video
		return <Zoom in>
			<Link className="video_a"
				to={`v/${short_code}`}
				onMouseOver={() => {
					this.refs[short_code].play()
					ReactGA.event({
						category: 'Video',
						action: `Previewed ${premium ? 'Premium' : 'Free'} Video`,
						label: short_code
					})
				}}
				onMouseLeave={() => this.refs[short_code].pause()}
				onClick={() => {
					ReactGA.event({
						category: 'Video',
						action: `Clicked ${premium ? 'Premium' : 'Free'} Video`,
						label: short_code
					})
				}}
			>
				<video muted="muted" ref={short_code} className='video_thumbnail' poster={thumb_url} loop preload="none">
					<source src={preview_url} type="video/mp4" />
				</video>
				{premium && user_premium && <Icon size={50} icon={ic_check_circle} className='is_premium' />}
				{premium && !user_premium && <Icon size={50} icon={lock} className='is_premium' />}
			</Link>
		</Zoom>
	}
}


const mapStateToProps = ({ premium }) => ({ premium })


export default connect(mapStateToProps)(VideoThumb)